import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { DataTableDirective } from 'angular-datatables';
import { AuctionFilter } from '../../models/auction-filter';
import { environment } from '../../../../../environments/environment';
import { BusAuctionFilterService } from '../../services/bus-auction-filter.service';
import { Angular5Csv } from 'angular5-csv/dist/Angular5-csv';
import { AuctionMainTable } from '../../models/auction-main-table';
import { NgxSpinnerService } from 'ngx-spinner';

const apiServer = environment.apiServer;
declare var $: any;
class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}

@Component({
  selector: 'app-home-main-table',
  templateUrl: './home-main-table.component.html',
  styleUrls: ['./home-main-table.component.sass']
})

export class HomeMainTableComponent implements OnInit, AfterViewInit {

  @ViewChild(DataTableDirective) datatableElement: DataTableDirective;

  dataSetAuction: any;  
  dtOptionsAuctions: DataTables.Settings = {};
  modelAuctionFilter: AuctionFilter = new AuctionFilter();
  modelAuctionMainTable: AuctionMainTable[];
  filterIsNotNull:boolean = true;
  defaultDateFrom: string;
  defaultDateTo: string;
  route: ActivatedRoute;

  dt: DataTables.Api;

  constructor(private http: HttpClient, private bus: BusAuctionFilterService, private spinner: NgxSpinnerService, private _route: ActivatedRoute) {
    this.modelAuctionMainTable = [];
    this.defaultDateFrom = this.getDateYYYYMMDD();
    this.defaultDateTo = this.getDateYYYYMMDD(true);
    this.route = _route;

    const routeId =  this.route.snapshot.paramMap.get('id');
    if ( routeId){
      setTimeout(() => {  
        this.onRowClick(routeId);
        $('#modalAuctionDetail').modal('show'); 
      }, 3000);
    }
  }

  onFieldChange(): void {
    this.dt.ajax.reload();
    this.modelAuctionMainTable = [];
    this.spinner.show();    
  }

  onSelectedStatus(status) {
    this.modelAuctionFilter.status = status;
    this.bus.changeFilter(this.modelAuctionFilter);
    this.onFieldChange();
    this.spinner.show();
  }

  //Статус согласования аукциона
  onAdjustmentStatus(status) {
    this.modelAuctionFilter.aucAgreementStatus = status;
    this.onFieldChange();
    this.spinner.show();
  }

  onExport(): void {
    this.modelAuctionMainTable = [];

    const optionsCvs = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalseparator: '.',
      showLabels: true,
      showTitle: true,
      useBom: true,
      noDownload: false,
      headers: [
        'Статус',
        'ID',
        'Дата подачи',
        'Дата аукциона',
        'Регион',
        'Заказчик',
        'Сумма',
        'Дистр-Участник',
        'Дистр-Победитель',
        'КАМ']
    };

    const filter = {
      DateAucFrom: this.modelAuctionFilter.dateAucFrom,
      DateAucTo: this.modelAuctionFilter.dateAucTo,
      DateSubmissionFrom: this.modelAuctionFilter.dateSubmissionFrom,
      DateSubmissionTo: this.modelAuctionFilter.dateSubmissionTo,
      IsNewAuc: this.modelAuctionFilter.isNewAuc,
      IsStatusAucLost: this.modelAuctionFilter.statusAucLost,
      IsStatusAucPreliminaryStudy: this.modelAuctionFilter.statusAucPreliminaryStudy,
      IsStatusAucRefusalOfParticipation: this.modelAuctionFilter.statusAucRefusalOfParticipation,
      IsStatusAucRejected: this.modelAuctionFilter.statusAucRejected,
      IsStatusAucWin: this.modelAuctionFilter.statusAucWin,
      IsStatusAucWorked: this.modelAuctionFilter.statusAucWorked,
      SearchMainField: this.modelAuctionFilter.searchMainField,
      Contractor: this.modelAuctionFilter.contractor,
      Mnn: this.modelAuctionFilter.mnn,
      region: this.modelAuctionFilter.region,
      distrWinner: this.modelAuctionFilter.distrWinner,
      distrMember: this.modelAuctionFilter.distrMember,
      manager: this.modelAuctionFilter.kam,
      status: this.modelAuctionFilter.status,
      aucAgreementStatus: this.modelAuctionFilter.aucAgreementStatus,
      amountPosition: this.modelAuctionFilter.amountPosition,
      start: 0,
      length: 100000,
      columns: [
        {
          data: 'StatusAuc', name: 'statusAuc'
        }
      ],
      order: [{
        column: 0, dir: 'asc'
      }]
    };

    this.http.post<any>(`${apiServer}/auction`, filter, {}).subscribe(result => {
      result.data.forEach(item => {
        const auctionItem = new AuctionMainTable();
        for (const key in item) {
          if (key in auctionItem) {
            if (key === 'code') {
              auctionItem[key] = item[key] + ' ';
            } else {
              auctionItem[key] = item[key];
            }
            if (auctionItem[key] == null) {
              auctionItem[key] = '';
            }
          }
        }
        this.modelAuctionMainTable.push(auctionItem);
      });
            
      const n = new Angular5Csv(this.modelAuctionMainTable, 'Auctions', optionsCvs);
    });

  }

  onDateChange(event) {
    this.modelAuctionFilter[event.target.name] = event.target.value;
    if(event.target.value != null){
    }
    this.filterIsNotNull = false;
    this.bus.changeFilter(this.modelAuctionFilter);

    //this.dt.ajax.reload();
    this.modelAuctionMainTable = [];
    //this.spinner.show();   

    //this.onFieldChange();
  }

  onRowClick(auctionNumber: string) {
    this.bus.changeAuctionNumber(auctionNumber);
  }
  onClearTotal() {
    this.modelAuctionFilter.dateAucFrom = "";
    this.modelAuctionFilter.dateAucTo = "";
    this.modelAuctionFilter.dateSubmissionFrom = null;
    this.modelAuctionFilter.dateSubmissionTo = null;
    this.modelAuctionFilter.isNewAuc = 0;
    this.modelAuctionFilter.statusAucLost = 0;
    this.modelAuctionFilter.statusAucPreliminaryStudy = 0;
    this.modelAuctionFilter.statusAucRefusalOfParticipation = 0;
    this.modelAuctionFilter.statusAucRejected = 0;
    this.modelAuctionFilter.statusAucWin = 0;
    this.modelAuctionFilter.statusAucWorked = 0;
    this.modelAuctionFilter.searchMainField = null;
    this.modelAuctionFilter.kam = null;
    this.modelAuctionFilter.status = null;
    this.modelAuctionFilter.aucAgreementStatus = null;

    this.bus.changeClearModalFilter('contractor');
    this.bus.changeClearModalFilter('mnn');
    this.bus.changeClearModalFilter('region');
    this.bus.changeClearModalFilter('distrMember');
    this.bus.changeClearModalFilter('distrWinner');
    this.bus.changeClearModalFilter('kam');

    this.filterIsNotNull = true;
    this.onFieldChange();
  }

  onClearModal(key: string) {
    this.filterIsNotNull = true;
    this.bus.changeClearModalFilter(key);
  }
  onClearSearchFields(key: string) {
    this.bus.changeClearSearchModalFields(key);
  }

  onClearDateFields(key: string) {
    this.filterIsNotNull = true;
    Object.keys(this.modelAuctionFilter).forEach(name => {
      if (name === key && this.modelAuctionFilter[name] != null) {
        
        switch (name) {
          case 'dateAucFrom':
              this.modelAuctionFilter[name] =  this.defaultDateFrom;
            break;
          case 'dateAucTo':
              this.modelAuctionFilter[name] =  this.defaultDateTo;
            break;
        
          default:
            this.modelAuctionFilter[name] = null;
            break;
        }
      }
    });
    this.onFieldChange();
  }


  ngOnInit() {
    this.bus.currentFilter$.subscribe(filter => {
      this.modelAuctionFilter = filter;
      if (this.dt != null) {
        this.onFieldChange();
      }
    });
    this.spinner.show();

    $('#dateAucFrom').val(this.defaultDateFrom); 
    this.modelAuctionFilter.dateAucFrom = this.defaultDateFrom;

    $('#dateAucTo').val(this.defaultDateTo); 
    this.modelAuctionFilter.dateAucTo = this.defaultDateTo;


    const that = this;

    this.dtOptionsAuctions = {
      pagingType: 'full_numbers',
      pageLength: 100,
      serverSide: true,
      processing: true,
      autoWidth: true,
      dom: 'tip',
      info: false,
      scrollY: 'calc(100vh - 230px)',
       //scrollCollapse: true,
       //scrollX: true,
      language: {
        emptyTable: 'Нет данных',
        info: 'Отображено с _START_ по _END_ из _TOTAL_ записей',
        infoEmpty: 'Отображено с 0 по 0 из 0 записей',
        infoFiltered: '(отфильтровано из _MAX_ записей)',
        infoPostFix: '',
        thousands: ',',
        lengthMenu: 'Показывать по _MENU_ записей',
        loadingRecords: 'Загрузка ...',
        processing: 'Обработка ...',
        search: 'Поиск:',
        zeroRecords: '',
        paginate: {
          first: 'Первая',
          last: 'Последняя',
          next: 'След.',
          previous: 'Пред.'
        },
        aria: {
          sortAscending: ': activate to sort column ascending',
          sortDescending: ': activate to sort column descending'
        }
      },
      ajax: (dataTablesParameters: any, callback) => {
        // dataTablesParameters.DateAucFrom = this.modelAuctionFilter.dateAucFrom;
        // dataTablesParameters.DateAucTo = this.modelAuctionFilter.dateAucTo;

        // this.modelAuctionFilter.dateAucFrom = ( this.modelAuctionFilter.dateAucFrom == "") ? this.defaultDateFrom :  this.modelAuctionFilter.dateAucFrom;
        // this.modelAuctionFilter.dateAucTo = ( this.modelAuctionFilter.dateAucTo == "") ? this.defaultDateTo :  this.modelAuctionFilter.dateAucTo;
        dataTablesParameters.DateAucFrom = this.modelAuctionFilter.dateAucFrom;
        dataTablesParameters.dateAucTo = this.modelAuctionFilter.dateAucTo;
        
        if(new Date(this.modelAuctionFilter.dateAucFrom) < new Date(this.modelAuctionFilter.dateAucTo)){
        }


        dataTablesParameters.DateSubmissionFrom = this.modelAuctionFilter.dateSubmissionFrom;
        dataTablesParameters.DateSubmissionTo = this.modelAuctionFilter.dateSubmissionTo;
        dataTablesParameters.IsNewAuc = this.modelAuctionFilter.isNewAuc;
        dataTablesParameters.IsStatusAucLost = this.modelAuctionFilter.statusAucLost;
        dataTablesParameters.IsStatusAucPreliminaryStudy = this.modelAuctionFilter.statusAucPreliminaryStudy;
        dataTablesParameters.IsStatusAucRefusalOfParticipation = this.modelAuctionFilter.statusAucRefusalOfParticipation;
        dataTablesParameters.IsStatusAucRejected = this.modelAuctionFilter.statusAucRejected;
        dataTablesParameters.IsStatusAucWin = this.modelAuctionFilter.statusAucWin;
        dataTablesParameters.IsStatusAucWorked = this.modelAuctionFilter.statusAucWorked;
        dataTablesParameters.SearchMainField = this.modelAuctionFilter.searchMainField;
        dataTablesParameters.Contractor = this.modelAuctionFilter.contractor;
        dataTablesParameters.Mnn = this.modelAuctionFilter.mnn;
        dataTablesParameters.region = this.modelAuctionFilter.region;
        dataTablesParameters.distrWinner = this.modelAuctionFilter.distrWinner;
        dataTablesParameters.distrMember = this.modelAuctionFilter.distrMember;
        dataTablesParameters.manager = this.modelAuctionFilter.kam;
        dataTablesParameters.amountPosition = this.modelAuctionFilter.amountPosition;
        dataTablesParameters.status = this.modelAuctionFilter.status;
        dataTablesParameters.aucAgreementStatus = this.modelAuctionFilter.aucAgreementStatus;

        that.http.post<DataTablesResponse>(`${apiServer}/auction`, dataTablesParameters, {})
          .subscribe(resp => {
            that.dataSetAuction = resp.data;
            this.spinner.hide();
            callback({
              recordsTotal: resp.recordsTotal,
              recordsFiltered: resp.recordsFiltered,
              data: []
            });
          });
      },
      columns: [
        { data: 'StatusAuc', width: '60px'},
        { data: 'idAuc', width: '120px' },
        { data: 'dateSubmission', width: '110px' },
        { data: 'dateAuc', width: '130px' },
        { data: 'region' },
        { data: 'contractor', width: '510px' },
        { data: 'sumAuc' , width: '120px'  },
        { data: 'solopharmPriceSum' , width: '120px'  },
        { data: 'costPercentDiff' , width: '130px'  },
        { data: 'distrMember' , width: '120px' },
        { data: 'distrWinner' , width: '120px' },
        { data: 'kam' , width: '100px'},
        { data: 'amountPosition' , width: '40px'  }

      ]
    };

  }

  ngAfterViewInit(): void {
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      this.dt = dtInstance;
    });
    // new $.fn.dataTable.FixedHeader(this.datatableElement.dtInstance, {});

    $('.datetimepickers').each(function () {
      $(this).datetimepicker({
        locale: 'ru',
        format: 'YYYY-MM-DD',
        collapse: true,
        keepOpen: false,
        useCurrent: false,
        showClear: false

      });
    });

    $('[data-toggle="tooltip"]').tooltip();
  }

  getDateYYYYMMDD(to:boolean = false){
    if(!to){
      var dateTo = new Date();
      dateTo.setDate(new Date().getDate() - 50 );
      return dateTo.toISOString().slice(0,10);
    }
    else{
      return new Date().toISOString().slice(0,10);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/home/components/home-main-table/home-main-table.component.ts